/**
 * South Perry — Historical Walking Tour
 * MapSVG (map id 4) ↔ Foundation tabs + accordion bridge
 *
 * Requires, in the map's JavaScript tab:
 *   afterInit     → defines window.SPMap { highlight, clear, center } + fires 'spmap:ready'
 *   click.marker  → fires 'spmap:markerclick' with { detail: { id } }
 *
 * Enqueue in the footer, after jQuery and Foundation.
 */
jQuery(function ($) {
  const $tabs = $('#walking-tour');
  const $content = $('[data-tabs-content="walking-tour"]');
  const SMALL_SCREEN = '(max-width: 639px)';

  let pendingScrollId = null;

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  /* ---------- URL ---------- */

  const setHash = function ($pane) {
    const id = $pane.attr('id');
    if (id) history.replaceState(null, '', '#' + id);
  };

  const clearHash = function () {
    if (location.hash) history.replaceState(null, '', location.pathname + location.search);
  };

  /* ---------- tabs ---------- */

  const activateOwningTab = function ($pane) {
    const $panel = $pane.closest('.tabs-panel');
    if (!$panel.length || $panel.hasClass('is-active')) return false;

    const $link = $tabs.find('a[href="#' + $panel.attr('id') + '"]').first();
    if ($link.length) {
      $link.trigger('click');
      return true;
    }

    try {
      $tabs.foundation('selectTab', $panel);
      return true;
    } catch (err) {
      return false;
    }
  };

  /* ---------- open a pane (marker click, next button, deep link) ---------- */

  const openPane = function ($pane) {
    pendingScrollId = $pane.attr('id') || null;

    const go = function () {
      $pane.closest('.accordion').foundation('down', $pane);
      setHash($pane);
    };

    if (activateOwningTab($pane)) {
      setTimeout(go, 60);
    } else {
      go();
    }
  };

  /* ---------- map follows the DOM ---------- */

  const syncFromDom = function (allowClearHash) {
    if (!window.SPMap) return;

    const $pane = $content
      .find('.tabs-panel.is-active .accordion-content[aria-hidden="false"]').first();
    const id = $pane.attr('data-marker-id');

    if ($pane.length && id) {
      window.SPMap.highlight(id);
    } else {
      window.SPMap.clear();
      if (allowClearHash) clearHash();
    }
  };

  /* ---------- deep link on load ---------- */

  const handleHashOnLoad = function () {
    const id = location.hash.slice(1);
    if (!id) return;

    const $pane = $content.find('.accordion-content[id="' + id + '"]').first();
    if (!$pane.length) return;

    activateOwningTab($pane);

    if ($pane.attr('aria-hidden') === 'false') {
      const $title = $pane.closest('.accordion-item').find('.accordion-title').first();
      setTimeout(function () {
        if ($title.length) $title[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    } else {
      pendingScrollId = id;
      setTimeout(function () {
        if ($pane.attr('aria-hidden') !== 'false') openPane($pane);
      }, 600);
    }
  };

  /* ---------- accordion events ---------- */

  $content.on('down.zf.accordion', '.accordion', function (e, $pane) {
    activateOwningTab($pane);

    const id = $pane.attr('data-marker-id');
    if (id && window.SPMap) {
      window.SPMap.highlight(id);
      if (window.SPMap.center && window.matchMedia(SMALL_SCREEN).matches) {
        window.SPMap.center(id);
      }
    }

    if (pendingScrollId && $pane.attr('id') === pendingScrollId) {
      pendingScrollId = null;
      const $title = $pane.closest('.accordion-item').find('.accordion-title').first();
      if ($title.length) {
        requestAnimationFrame(function () {
          $title[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  });

  $content.on('up.zf.accordion', '.accordion', function () {
    setTimeout(function () { syncFromDom(true); }, 0);
  });

  /* ---------- tab events ---------- */

  $tabs.on('change.zf.tabs', function () {
    setTimeout(function () { syncFromDom(true); }, 0);
  });

  /* ---------- map → accordion ---------- */

  document.addEventListener('spmap:markerclick', function (e) {
    const $pane = $content
      .find('.accordion-content[data-marker-id="' + e.detail.id + '"]').first();
    if ($pane.length) openPane($pane);
  });

  /* ---------- next stop button ---------- */

  $content.on('click', '.next-stop', function (e) {
    e.preventDefault();
    const $item = $(this).closest('.accordion-item');
    const $next = $item.next('.accordion-item');
    if (!$next.length) return;
    openPane($next.find('.accordion-content').first());
  });

  /* ---------- initial state ---------- */

  syncFromDom(false);
  document.addEventListener('spmap:ready', function () { syncFromDom(false); });

  $(window).on('load', function () {
    handleHashOnLoad();
  });
});